import {useState} from 'react'

export const useToggle = (initialValue: boolean = false): [boolean, () => void, (value: boolean) => void] => {
  const [open, setOpen] = useState(initialValue)

  const toggle = () => {
    setOpen(!open)
  }

  const set = (value: boolean) => {
    setOpen(value)
  }

  return [open, toggle, set]
}
